import React, {useEffect, useState} from "react";

import {Badge, IconButton, useMediaQuery, useTheme} from "@mui/material";
import NavbarStyles from "../styles/Navbar.module.css";

import {useAuth} from "../context/authContext";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MenuIcon from "@mui/icons-material/Menu";
import {useSystemAlertContext} from "../context/SystemAlertContext";
import FlyzoneWhiteLogo from "../assests/Flyzone White Logo-01.svg";

function Navbar({ onMenuClick }) {
    const {authenticated} = useAuth();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const {hasAlerts, alerts, showAlertModal} = useSystemAlertContext();

    //Date time Picker Function
    const [isDateTimePickerOpen, setDateTimePickerOpen] = useState(false);

    useEffect(() => {
        const handleCloseModal = (event) => {
            if (
                isDateTimePickerOpen &&
                event.target.closest(".date-time-picker-modal") === null &&
                event.target.closest(".datetime") === null
            ) {
                setDateTimePickerOpen(false);
            }
        };
        document.addEventListener("mousedown", handleCloseModal);
        return () => {
            document.removeEventListener("mousedown", handleCloseModal);
        };
    }, [isDateTimePickerOpen]);

    const authNav = authenticated ? (
        <div className={NavbarStyles.Navbar}>
            {/* Hamburger Menu for Mobile */}
            {isMobile && (
                <IconButton
                    color="inherit"
                    aria-label="Open menu"
                    edge="start"
                    onClick={onMenuClick}
                    className={NavbarStyles.MenuButton}
                    sx={{ mr: 2, color: '#1e3a8a' }}
                >
                    <MenuIcon />
                </IconButton>
            )}
            <img
                src={FlyzoneWhiteLogo}
                alt="Flyzone Logo"
                className={NavbarStyles.Logo}
            />
            <div className={NavbarStyles.NavItems}>
                {/* System Alert Notification Icon */}
                <IconButton
                    color="inherit"
                    onClick={showAlertModal}
                    className={NavbarStyles.NotificationIcon}
                    aria-label="System notifications"
                >
                    <Badge
                        badgeContent={alerts.length}
                        color="error"
                        invisible={!hasAlerts}
                    >
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
            </div>
        </div>
    ) : (
        <div className={NavbarStyles.Navbar}>
            {/* Hamburger Menu for Mobile (non-authenticated) */}
            {isMobile && (
                <IconButton
                    color="inherit"
                    aria-label="Open menu"
                    edge="start"
                    onClick={onMenuClick}
                    className={NavbarStyles.MenuButton}
                    sx={{ mr: 2, color: '#1e3a8a' }}
                >
                    <MenuIcon />
                </IconButton>
            )}
            <img
                src={FlyzoneWhiteLogo}
                alt="Flyzone Logo"
                className={NavbarStyles.Logo}
            />
            <div className={NavbarStyles.NavItems}>
                {/* System Alert Notification Icon */}
                <IconButton
                    color="inherit"
                    onClick={showAlertModal}
                    className={NavbarStyles.NotificationIcon}
                >
                    <Badge
                        badgeContent={alerts.length}
                        color="error"
                        invisible={!hasAlerts}
                    >
                        <NotificationsIcon />
                    </Badge>
                </IconButton>
            </div>
        </div>
    );
    return (
        <React.Fragment>
            <section className={NavbarStyles.navbarbackground}>{authNav}</section>
        </React.Fragment>
    );
}

export default Navbar;